import { useRef, useState } from "react";
import ExportIcon from "@/assets/summary/download.svg";
import summaryCommonStore from "@/store/summaryCommon.store";
import AIIcon from "@/assets/common/ic_ai_icon.svg";
import fridayReporter from "@/utils/friday";
import { Origin } from "@/constants/share";
import MobileExpire from "../MobileExpire";
import MobileExportModal, {
  MobileExportModalRef,
} from "@/component/MobileExportModal";
interface FooterProps {
  onSave: () => void;
  saving: boolean;
  showExportAudio?: boolean;
}

export default function Footer(props: FooterProps) {
  const { onSave, saving } = props;
  const exportModalRef = useRef<MobileExportModalRef>(null);

  const shareInfo = summaryCommonStore((state) => state.shareInfo);

  const handleSave = () => {
    fridayReporter.pushData({
      eventCode: "summary_h5_save",
    });
    if (saving) return;
    onSave();
  };

  const [showExpire, setShowExpire] = useState(true);
  const handleShowDownloadModal = () => {
    exportModalRef.current?.show();
  };

  return (
    <div className="w-full mobile-page bg-white">
      {shareInfo?.origin !== Origin.MAX_LINK &&
        process.env.BUILD_TYPE !== "private" && (
          <MobileExpire
            visible={showExpire}
            onClose={() => {
              setShowExpire(false);
            }}
          />
        )}
      {process.env.BUILD_TYPE === "private" ? (
        <div
          className="h-14 flex items-center justify-center text-4 text-mx-secondary"
          onClick={handleShowDownloadModal}
        >
          <img className="size-6 mr-0.5" src={ExportIcon} alt="" />
          本地下载
        </div>
      ) : (
        <div className="h-14 flex items-center justify-center text-3.5 text-mx-secondary">
          <div
            className="color-#191D26 rd-3 px-4.75 py-2.5 h-10 w-40 flex justify-center items-center border-solid border-#191D26 border-1 mr-6"
            onClick={handleShowDownloadModal}
          >
            <img className="w-6 h-6 mr-0.5" src={ExportIcon} />
            本地下载
          </div>
          <div
            className={`${
              saving ? "opacity-30" : ""
            }  bg-#4981F2 color-white rd-3 px-4.75 py-2.5 h-10 w-40 flex justify-center items-center`}
            onClick={handleSave}
          >
            <img className="w-6 h-6 mr-0.5" src={AIIcon} />
            保存至AI会记
          </div>
        </div>
      )}
      <MobileExportModal
        ref={exportModalRef}
      />
    </div>
  );
}
